<template>
  <div class="contact">
    <div class="hero"></div>
    <main class="wrapper">
      <h2>Contact Us</h2>
      <p>Your questions and inquiries are important to us.</p>
      <p>Please call us during business hours at 905-597-7780 or emil us at info@chronicle-financial.com</p>

      <div class="address">
        <p>Our office is located at.</p>
        <p>Unit 19, 20 Wertheim Crt.</p>
        <p>Richmond Hill, ON</p>
        <p>L4B 3A8</p>
        <a href="https://goo.gl/maps/FzpLf9zL82T2"><p>Click Here to Open in Google Maps</p></a>
      </div>

      <p>Free parking is available.</p>
    </main>

    <div class="map wrapper">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.4699915740503!2d-79.38730433415722!3d43.846086379115214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2b4bca45ea0f%3A0x4fb902ee3bb86463!2s20+Wertheim+Ct+%2319%2C+Richmond+Hill%2C+ON+L4B+3H7!5e0!3m2!1sen!2sca!4v1534479932706" width="800" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  created: function() {
		var activeLink = document.getElementsByClassName("navLink")[3];

    activeLink.parentElement.classList.add("active");
    activeLink.parentElement.classList.remove("inactive");
	},
	destroyed: function() {
		var activeLink = document.getElementsByClassName("navLink")[3];

    activeLink.parentElement.classList.remove("active");
    activeLink.parentElement.classList.add("inactive");
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../scss/styles.scss';
  @import './scss/styles.scss';
</style>
